"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Notification", {
    enumerable: true,
    get: function() {
        return Notification;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
var _types = require("./types");
var _react1 = require("@headlessui/react");
var _xicon = /*#__PURE__*/ _interopRequireDefault(require("@heroicons/react/solid/XIcon"));
var _exclamationIcon = /*#__PURE__*/ _interopRequireDefault(require("@heroicons/react/outline/ExclamationIcon"));
var _checkCircleIcon = /*#__PURE__*/ _interopRequireDefault(require("@heroicons/react/outline/CheckCircleIcon"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
var Notification = function(param) {
    var notification = param.notification, onClose = param.onClose;
    var layout = notification.layout, icon = notification.icon, _notification_type = notification.type, type = _notification_type === void 0 ? "success" : _notification_type, title = notification.title, text = notification.text, actionTitle = notification.actionTitle, _notification_dismissTitle = notification.dismissTitle, dismissTitle = _notification_dismissTitle === void 0 ? "Dismiss" : _notification_dismissTitle, onAction = notification.onAction, _notification_hasClose = notification.hasClose, hasClose = _notification_hasClose === void 0 ? false : _notification_hasClose, _notification_timeOut = notification.timeOut, timeOut = _notification_timeOut === void 0 ? 3000 : _notification_timeOut, show = notification.show;
    var handleClose = function() {
        if (notification === null || notification === void 0 ? void 0 : notification.onClose) {
            notification.onClose();
        }
        onClose(notification.id);
    };
    var handleAction = function() {
        if (notification === null || notification === void 0 ? void 0 : notification.onAction) {
            notification.onAction();
        }
        onClose(notification.id);
    };
    (0, _react.useEffect)(function() {
        if (!onAction && !hasClose) {
            setTimeout(handleClose, timeOut);
        }
    }, []);
    var whiteBg = type === "success" || type === "warning";
    var redBg = type === "error";
    var classes = {
        root: (0, _classnames.default)("max-w-sm w-full shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden", {
            "bg-white": whiteBg,
            "bg-red-600": redBg
        }),
        flex: (0, _classnames.default)("flex", {
            "items-center": layout === _types.NotificationLayout.CONDENSED,
            "items-start": layout === _types.NotificationLayout.ACTIONS_BELOW || layout === _types.NotificationLayout.SIMPLE
        })
    };
    var defaultIcon = null;
    if (type === "success") {
        defaultIcon = /*#__PURE__*/ _react.default.createElement(_checkCircleIcon.default, {
            className: "h-6 w-6 text-accent-400",
            "aria-hidden": "true"
        });
    } else if (type === "warning") {
        defaultIcon = /*#__PURE__*/ _react.default.createElement(_exclamationIcon.default, {
            className: "h-6 w-6 text-yellow-400"
        });
    } else if (type === "error") {
        defaultIcon = /*#__PURE__*/ _react.default.createElement(_exclamationIcon.default, {
            className: "h-6 w-6 text-white"
        });
    }
    return /*#__PURE__*/ _react.default.createElement(_react1.Transition, {
        show: show,
        appear: true,
        as: _react.Fragment,
        enter: "transform ease-out duration-300 transition",
        enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
        enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
        leave: "transition ease-in duration-100",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: classes.root
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: "p-4"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: classes.flex
    }, (icon || defaultIcon) && /*#__PURE__*/ _react.default.createElement("div", {
        className: "flex-shrink-0 mr-3"
    }, icon || defaultIcon), layout === _types.NotificationLayout.SIMPLE && /*#__PURE__*/ _react.default.createElement("div", {
        className: "w-0 flex-1 pt-0.5"
    }, /*#__PURE__*/ _react.default.createElement("p", {
        className: (0, _classnames.default)("text-sm font-medium", {
            "text-gray-900": whiteBg,
            "text-white": redBg
        })
    }, title), text && /*#__PURE__*/ _react.default.createElement("p", {
        className: (0, _classnames.default)("mt-1 text-sm", {
            "text-gray-500": whiteBg,
            "text-gray-50": redBg
        })
    }, text)), layout === _types.NotificationLayout.CONDENSED && /*#__PURE__*/ _react.default.createElement("div", {
        className: "w-0 flex-1 flex justify-between"
    }, /*#__PURE__*/ _react.default.createElement("p", {
        className: (0, _classnames.default)("w-0 flex-1 text-sm font-medium", {
            "text-gray-900": whiteBg,
            "text-white": redBg
        })
    }, title), actionTitle && /*#__PURE__*/ _react.default.createElement("button", {
        type: "button",
        className: (0, _classnames.default)("ml-3 flex-shrink-0  rounded-md text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2", {
            "bg-white text-accent-600 hover:text-accent-500 focus:ring-accent-500": whiteBg,
            "bg-red-600 text-white hover:text-gray-50 focus:ring-ray-50": redBg
        }),
        onClick: handleAction
    }, actionTitle)), layout === _types.NotificationLayout.ACTIONS_BELOW && /*#__PURE__*/ _react.default.createElement("div", {
        className: "w-0 flex-1 pt-0.5"
    }, /*#__PURE__*/ _react.default.createElement("p", {
        className: (0, _classnames.default)("text-sm font-medium", {
            "text-gray-900": whiteBg,
            "text-white": redBg
        })
    }, title), text && /*#__PURE__*/ _react.default.createElement("p", {
        className: "mt-1 text-sm text-gray-500"
    }, text), /*#__PURE__*/ _react.default.createElement("div", {
        className: "mt-3 flex space-x-7"
    }, actionTitle && /*#__PURE__*/ _react.default.createElement("button", {
        type: "button",
        className: (0, _classnames.default)("rounded-md text-sm font-medium  focus:outline-none focus:ring-2 focus:ring-offset-2", {
            "bg-white text-accent-600 hover:text-accent-500 focus:ring-accent-500": whiteBg,
            "bg-red-600 text-white hover:text-gray-50 focus:ring-gray-50": redBg
        }),
        onClick: handleAction
    }, actionTitle), /*#__PURE__*/ _react.default.createElement("button", {
        type: "button",
        className: (0, _classnames.default)("rounded-md text-sm font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2", {
            "bg-white focus:ring-accent-500": whiteBg,
            "bg-red focus:ring-gray-50": redBg
        }),
        onClick: handleClose
    }, dismissTitle))), hasClose && /*#__PURE__*/ _react.default.createElement("div", {
        className: "ml-4 flex-shrink-0 flex"
    }, /*#__PURE__*/ _react.default.createElement("button", {
        className: (0, _classnames.default)("rounded-md inline-flex  focus:outline-none focus:ring-2 focus:ring-offset-2", {
            "bg-white focus:ring-accent-500 text-gray-400 hover:text-gray-500": whiteBg,
            "bg-red focus:ring-gray-50 text-white hover:text-gray-50": redBg
        }),
        onClick: handleClose
    }, /*#__PURE__*/ _react.default.createElement("span", {
        className: "sr-only"
    }, "Close"), /*#__PURE__*/ _react.default.createElement(_xicon.default, {
        className: "h-5 w-5",
        "aria-hidden": "true"
    })))))));
};

//# sourceMappingURL=Notification.js.map